import React from 'react';
import { AppModule } from '../../core';
import { DashboardLayout, DashboardEditingLayout } from '../../core/layouts';

const coursesModule: AppModule = {
  routes: [
    {
      path: '/courses',
      exact: true,
      layout: DashboardLayout,
      page: React.lazy(() => import('./pages/courses-v2')),
    },
    {
      path: '/courses/:courseId/modules/:labId',
      exact: true,
      name: 'Module Page',
      layout: DashboardEditingLayout,
      page: React.lazy(() => import('../lab/pages/lab-v2')),
    },
    {
      path: '/courses/:courseId/modules/:labId/moduleAttempts/:labAttemptId',
      exact: true,
      name: 'Student Module Page',
      layout: DashboardEditingLayout,
      page: React.lazy(() => import('../lab/pages/lab-student')),
    },
    {
      path: '/courses/:courseId/modules/:labId/students/:studentId/grade',
      exact: true,
      name: 'Grade Module Page',
      layout: DashboardEditingLayout,
      page: React.lazy(() => import('../lab/pages/grade-lab')),
    },
    {
      path: '/courses-management',
      exact: true,
      permissions: ['Teacher', 'Admin'],
      layout: DashboardLayout,
      page: React.lazy(() => import('./pages/courses-management-v2')),
    },
    {
      path: '/client-courses-management',
      exact: true,
      permissions: ['Admin'],
      layout: DashboardLayout,
      page: React.lazy(() => import('./pages/client-courses-management-v2')),
    },
    {
      path: '/global-courses-management',
      exact: true,
      permissions: ['Admin'],
      layout: DashboardLayout,
      page: React.lazy(() => import('./pages/global-courses-management-v2')),
    },
  ],
};

export default coursesModule;
